<template>
  <div class="header">
    <v-row justify="center" align="end">
      <v-col cols="4" class="logo">
        <router-link to="/"><v-img :src="require('../assets/logo.png')" id="logo" /></router-link>
      </v-col>
      <v-col cols="8" class="menu">
        <router-link class="menu-item"
                     to="/virtualis-kiallitasok">Virtuális kiállítások
        </router-link>
        <router-link to="/hatartortenetek" class="menu-item">Határtörténetek</router-link>
        <router-link to="/az-en-tortenetem" class="menu-item">Az én történetem</router-link>
        <router-link to="/a-nagy-haboru-emlekei" class="menu-item">A nagy háború emlékei
        </router-link>
        <router-link to="https://muzeumpedagogiaonline.skanzen.hu/" class="menu-item">Múzeumpedagógia</router-link>
      </v-col>
    </v-row>
    <v-row height="11" justify="center">
      <v-col cols="12" class="grey-bar">
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Header',
};
</script>

<style lang="scss">
  @import "../assets/style/style";
</style>
